<template>
    <div>
        <div class="row">
            <div class="col text-center">
                <center><img class="icon" src="/hymns-icon-114-iPhone-2x.png" /></center>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col text-center">
                <h1>Hymnbooks</h1>
            </div>
        </div>
        <div class="row mt-5">
            <div class="col col-md-6 offset-md-3">
                <p>
                    The Hymnbooks app gives you the ability to search and browse hymnbooks on your mobile device and desktop.
                </p>
                <p>
                    Features:
                    <ul>
                        <li>Search for words or by number.</li>
                        <li>Hymn display highlights searched words.</li>
                        <li>Browse through the search results or the entire hymnbook.</li>
                        <li>Easily swipe to the next or previous hymn in the search results.</li>
                        <li>Two themes included, dark and light.</li>
                        <li>Default font size can be changed in settings.</li>
                    </ul>
                </p>
            </div>
        </div>
        <div class="row mt-5">
            <div class="col col-md-4 offset-md-4">
                <a v-bind:href="links.android_google" target="_blank">
                    <button type="button" class="btn btn-dark btn-lg w-100 text-start"><i class="fab fa-google-play"></i>&nbsp;&nbsp;&nbsp;Hymnbooks for <b>Android</b></button>
                </a>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col col-md-4 offset-md-4">
                <a v-bind:href="links.android_amazon" target="_blank">
                    <button type="button" class="btn btn-dark btn-lg w-100 text-start"><i class="fab fa-amazon"></i>&nbsp;&nbsp;&nbsp;Hymnbooks for <b>Android</b></button>
                </a>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col col-md-4 offset-md-4">
                <a v-bind:href="links.ios" target="_blank">
                    <button type="button" class="btn btn-dark btn-lg w-100 text-start"><i class="fab fa-app-store-ios"></i>&nbsp;&nbsp;&nbsp;Hymnbooks for <b>iOS / iPadOS</b></button>
                </a>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col col-md-4 offset-md-4">
                <a v-bind:href="links.macos" target="_blank">
                    <button type="button" class="btn btn-dark btn-lg w-100 text-start"><i class="fab fa-apple"></i>&nbsp;&nbsp;&nbsp;Hymnbooks for <b>macOS</b></button>
                </a>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col col-md-4 offset-md-4">
                <a v-bind:href="links.windows" target="_blank">
                    <button type="button" class="btn btn-dark btn-lg w-100 text-start"><i class="fab fa-windows"></i>&nbsp;&nbsp;&nbsp;Hymnbooks for <b>Windows</b></button>
                </a>
            </div>
        </div>
        <div class="row mt-5">
            <div class="col text-center">
                <p>
                    For questions and comments please contact <a href="mailto:apps@bibles-direct.co.uk">apps@bibles-direct.co.uk</a>
                    <br>
                    <br>
                    <router-link to="/hymnbooks/privacy">
                        Privacy Policy
                    </router-link>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'HymnbooksApp',
    created() {
        this.$store.dispatch('loadLinkData')
    },
    computed: {
        links() {
            return this.$store.getters.getLinks
        }
    }
}
</script>

<style lang="scss">
    .icon {
        width: 100px;
        height: 100px;
        border: 0px solid #111;
        border-radius: 15px;
        -moz-border-radius: 15px;
        -webkit-border-radius: 15px;
    }
</style>
